/**
 * Los permisos de Embajadores que la interfaz mira.
 *
 * La lista buena es la del API (`transport/catalog/permissions.ts`): de ahí
 * salen los que se dan de alta en lala-ms, y el API valida cada herramienta
 * contra ellos. Aquí solo están los que deciden qué se ENSEÑA, con el mismo
 * texto, para que un nombre mal escrito no compile en vez de esconder un botón
 * a todo el mundo sin que nadie se entere.
 *
 * La interfaz esconde; el backend decide. Quitar un botón no protege nada.
 */
export const PERMISSIONS = {
  /** Entrar a la aplicación (§10.2). */
  access: "embajadores:global.view",
  /** Todo: satisface cualquier otro, incluido `access` (§10.2). */
  manage: "embajadores:global.manage",

  participantsRead: "embajadores:participants.read",
  participantsWrite: "embajadores:participants.write",
  positionsRead: "embajadores:positions.read",
  positionsWrite: "embajadores:positions.write",
  regionsRead: "embajadores:regions.read",
  regionsWrite: "embajadores:regions.write",
  kpisRead: "embajadores:kpis.read",
  batchesRead: "embajadores:batches.read",
  mechanicsWrite: "embajadores:mechanics.write",
  memoryWrite: "embajadores:memory.write",
  /** El consumo de tokens: la sección de Work y el contador de la cabecera. */
  usageRead: "embajadores:usage.read",
  /** Sincronizar o fijar los precios de los modelos. */
  usageWrite: "embajadores:usage.write",
  /** La auditoría (`get_activity`). Aún no la usa ninguna pantalla. */
  activityRead: "embajadores:activity.read",
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

/**
 * Si quien tiene `held` puede `permission`. LA ÚNICA regla del front.
 *
 * `embajadores:global.manage` satisface cualquier permiso, igual que en el
 * chequeo del API: es una regla, no una lista, para que un permiso nuevo no se
 * quede sin él por olvido. `/me` devuelve los permisos tal cual, sin
 * expandir, así que la expansión vive aquí.
 */
export const hasPermission = (
  held: readonly string[],
  permission: Permission,
): boolean => held.includes(PERMISSIONS.manage) || held.includes(permission);
